import PropTypes from 'prop-types';
import './NewsItemProfile.scss';
import { useNavigate } from 'react-router-dom';

const NewsItemProfile = ({ news }) => {
    const navigate = useNavigate();
    
    return (
        <div className='new-container mb-4' onClick={() => navigate(`/news/${news.id}`)}>
            <div className='new-container-card'>
                {news.media_url?.length ? (
                    <img className='img-news' src={news.media_url} alt={news.title} />
                ) : (
                    <div className="img-news img-placeholder d-flex f-column aic jcc">
                    </div>
                )}
            </div>
            <p className='fg-crea fw-medium-bold mt-8 mb-0 new-title'>{news.title}</p>

        </div>
    )
}

NewsItemProfile.propTypes = {
    news: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        title: PropTypes.string.isRequired,
        content: PropTypes.string,
        created_at: PropTypes.string,
        media_url: PropTypes.string,
        likes: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
        comments: PropTypes.arrayOf(PropTypes.object),
        saved: PropTypes.oneOfType([
            PropTypes.bool,
            PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]))
        ]),
        users: PropTypes.shape({
            user_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            firstName: PropTypes.string,
            lastName: PropTypes.string,
            profilePicture: PropTypes.string
        })
    }).isRequired,
};

export default NewsItemProfile;